(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("classnames"), require("@material/list/dist/mdc.list.js"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "classnames", "@material/list/dist/mdc.list.js"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("classnames"), require("@material/list/dist/mdc.list.js")) : factory(root["react"], root["classnames"], root["@material/list/dist/mdc.list.js"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_5__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 56);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// The MIT License
//
// Copyright (c) 2018 Google, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var classnames_1 = __webpack_require__(1);
// @ts-ignore no .d.ts file
var mdc_list_1 = __webpack_require__(5);
var ListItem_1 = __webpack_require__(57); // eslint-disable-line no-unused-vars
exports.ListItem = ListItem_1.default;
var ListItemGraphic_1 = __webpack_require__(58);
exports.ListItemGraphic = ListItemGraphic_1.default;
var ListItemText_1 = __webpack_require__(59);
exports.ListItemText = ListItemText_1.default;
var ListItemMeta_1 = __webpack_require__(60);
exports.ListItemMeta = ListItemMeta_1.default;
var ListDivider_1 = __webpack_require__(61);
exports.ListDivider = ListDivider_1.default;
var ListGroup_1 = __webpack_require__(62);
exports.ListGroup = ListGroup_1.default;
var ListGroupSubheader_1 = __webpack_require__(63);
exports.ListGroupSubheader = ListGroupSubheader_1.default;
var ARIA_ORIENTATION = 'aria-orientation';
var VERTICAL = 'vertical';
var CHECKBOX_TYPE = 'checkbox';
;
;
function isCheckbox(element) {
    return element.type === CHECKBOX_TYPE;
}
function isReactText(element) {
    return typeof element === 'string' || typeof element === 'number';
}
function isListItem(element) {
    return element && element.type === ListItem_1.default;
}
var List = /** @class */ (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listItemCount = 0;
        _this.foundation = mdc_list_1.MDCListFoundation;
        _this.state = {
            focusListItemAtIndex: -1,
            followHrefAtIndex: -1,
            toggleCheckboxAtIndex: -1,
            // listItemAttributes: {index: {attr: value}}
            listItemAttributes: {
                0: {
                    tabIndex: 0,
                },
            },
            // listItemClassNames: {index: Array<String>}
            listItemClassNames: {},
            // listItemChildrenTabIndex: {index: Number}
            listItemChildrenTabIndex: {},
        };
        _this.handleKeyDown = function (e, index) {
            e.persist(); // Persist the synthetic event to access its `key`
            _this.foundation.handleKeydown(e, true /* isRootListItem is true if index >= 0 */, index);
            // Work around until MDC Web issue is resolved:
            // https://github.com/material-components/material-components-web/issues/4053
            if (index >= 0 &&
                (e.key === 'Enter' ||
                    e.keyCode === 13 ||
                    e.key === 'Space' ||
                    e.keyCode === 32)) {
                _this.props.handleSelect(index);
            }
        };
        _this.handleClick = function (e, index) {
            // Toggle the checkbox only if it's not the target of the event, or the checkbox will have 2 change events.
            var toggleCheckbox = isCheckbox(e.target);
            _this.foundation.handleClick(index, toggleCheckbox);
            // Work around until MDC Web issue is resolved:
            // https://github.com/material-components/material-components-web/issues/4053
            if (index >= 0) {
                _this.props.handleSelect(index);
            }
        };
        // Use onFocus as workaround because onFocusIn is not yet supported in React
        // https://github.com/facebook/react/issues/6410
        _this.handleFocus = function (e, index) {
            _this.foundation.handleFocusIn(e, index);
        };
        // Use onBlur as workaround because onFocusOut is not yet supported in React
        // https://github.com/facebook/react/issues/6410
        _this.handleBlur = function (e, index) {
            _this.foundation.handleFocusOut(e, index);
        };
        _this.renderChild = function (child) {
            if (!isReactText(child) && isListItem(child)) {
                return _this.renderListItem(child, _this.listItemCount++);
            }
            return child;
        };
        _this.renderListItem = function (listItem, index) {
            var _a = listItem.props, onKeyDown = _a.onKeyDown, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, otherProps = __rest(_a, ["onKeyDown", "onClick", "onFocus", "onBlur"]);
            var _b = _this.state, focusListItemAtIndex = _b.focusListItemAtIndex, followHrefAtIndex = _b.followHrefAtIndex, toggleCheckboxAtIndex = _b.toggleCheckboxAtIndex, listItemAttributes = _b.listItemAttributes, listItemClassNames = _b.listItemClassNames, listItemChildrenTabIndex = _b.listItemChildrenTabIndex;
            var props = __assign({}, otherProps, { onKeyDown: function (e) {
                    onKeyDown(e);
                    _this.handleKeyDown(e, index);
                }, onClick: function (e) {
                    onClick(e);
                    _this.handleClick(e, index);
                }, onFocus: function (e) {
                    onFocus(e);
                    _this.handleFocus(e, index);
                }, onBlur: function (e) {
                    onBlur(e);
                    _this.handleBlur(e, index);
                }, shouldFocus: focusListItemAtIndex === index, shouldFollowHref: followHrefAtIndex === index, shouldToggleCheckbox: toggleCheckboxAtIndex === index, attributesFromList: listItemAttributes[index], classNamesFromList: listItemClassNames[index], childrenTabIndex: listItemChildrenTabIndex[index] });
            return React.cloneElement(listItem, props);
        };
        return _this;
    }
    List.prototype.componentDidMount = function () {
        var _a = this.props, singleSelection = _a.singleSelection, wrapFocus = _a.wrapFocus, selectedIndex = _a.selectedIndex;
        this.foundation = new mdc_list_1.MDCListFoundation(this.adapter);
        this.foundation.init();
        this.foundation.setSingleSelection(singleSelection);
        if (singleSelection &&
            typeof selectedIndex === 'number' &&
            !isNaN(selectedIndex)) {
            this.foundation.setSelectedIndex(selectedIndex);
        }
        this.foundation.setWrapFocus(wrapFocus);
        this.foundation.setVerticalOrientation(this.props[ARIA_ORIENTATION] === VERTICAL);
    };
    List.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, singleSelection = _a.singleSelection, wrapFocus = _a.wrapFocus, selectedIndex = _a.selectedIndex;
        if (singleSelection !== prevProps.singleSelection) {
            this.foundation.setSingleSelection(singleSelection);
        }
        if (selectedIndex !== prevProps.selectedIndex &&
            typeof selectedIndex === 'number' &&
            !isNaN(selectedIndex)) {
            this.foundation.setSelectedIndex(selectedIndex);
        }
        if (wrapFocus !== prevProps.wrapFocus) {
            this.foundation.setWrapFocus(wrapFocus);
        }
        if (this.props[ARIA_ORIENTATION] !== prevProps[ARIA_ORIENTATION]) {
            this.foundation.setVerticalOrientation(this.props[ARIA_ORIENTATION] === VERTICAL);
        }
    };
    List.prototype.componentWillUnmount = function () {
        this.foundation.destroy();
    };
    Object.defineProperty(List.prototype, "classes", {
        get: function () {
            var _a = this.props, className = _a.className, nonInteractive = _a.nonInteractive, dense = _a.dense, avatarList = _a.avatarList, twoLine = _a.twoLine;
            return classnames_1.default('mdc-list', className, {
                'mdc-list--non-interactive': nonInteractive,
                'mdc-list--dense': dense,
                'mdc-list--avatar-list': avatarList,
                'mdc-list--two-line': twoLine,
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "adapter", {
        get: function () {
            var _this = this;
            return {
                getListItemCount: function () { return _this.listItemCount; },
                // Remove when MDC Web issue resolves:
                // https://github.com/material-components/material-components-web/issues/4058
                getFocusedElementIndex: function () { return -1; },
                setAttributeForElementIndex: function (index, attr, value) {
                    var listItemAttributes = _this.state.listItemAttributes;
                    attr = attr === 'tabindex' ? 'tabIndex' : attr;
                    if (!listItemAttributes[index]) {
                        listItemAttributes[index] = {};
                    }
                    listItemAttributes[index][attr] = value;
                    _this.setState({ listItemAttributes: listItemAttributes });
                },
                removeAttributeForElementIndex: function (index, attr) {
                    var listItemAttributes = _this.state.listItemAttributes;
                    attr = attr === 'tabindex' ? 'tabIndex' : attr;
                    if (!listItemAttributes[index]) {
                        return;
                    }
                    delete listItemAttributes[index][attr];
                    _this.setState({ listItemAttributes: listItemAttributes });
                },
                addClassForElementIndex: function (index, className) {
                    var listItemClassNames = _this.state.listItemClassNames;
                    if (!listItemClassNames[index]) {
                        listItemClassNames[index] = [];
                    }
                    listItemClassNames[index].push(className);
                    _this.setState({ listItemClassNames: listItemClassNames });
                },
                removeClassForElementIndex: function (index, className) {
                    var listItemClassNames = _this.state.listItemClassNames;
                    if (!listItemClassNames[index]) {
                        return;
                    }
                    var i = listItemClassNames[index].indexOf(className);
                    if (i >= 0) {
                        listItemClassNames[index].splice(i, 1);
                        _this.setState({ listItemClassNames: listItemClassNames });
                    }
                },
                setTabIndexForListItemChildren: function (listItemIndex, tabIndexValue) {
                    var listItemChildrenTabIndex = _this.state.listItemChildrenTabIndex;
                    listItemChildrenTabIndex[listItemIndex] = tabIndexValue;
                    _this.setState({ listItemChildrenTabIndex: listItemChildrenTabIndex });
                },
                focusItemAtIndex: function (index) {
                    _this.setState({ focusListItemAtIndex: index });
                },
                followHref: function (index) {
                    _this.setState({ followHrefAtIndex: index });
                },
                toggleCheckbox: function (index) {
                    _this.setState({ toggleCheckboxAtIndex: index });
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    List.prototype.render = function () {
        var _a = this.props, 
        /* eslint-disable no-unused-vars */
        className = _a.className, nonInteractive = _a.nonInteractive, dense = _a.dense, avatarList = _a.avatarList, twoLine = _a.twoLine, singleSelection = _a.singleSelection, selectedIndex = _a.selectedIndex, handleSelect = _a.handleSelect, wrapFocus = _a.wrapFocus, 
        /* eslint-enable no-unused-vars */
        children = _a.children, Tag = _a.tag, otherProps = __rest(_a, ["className", "nonInteractive", "dense", "avatarList", "twoLine", "singleSelection", "selectedIndex", "handleSelect", "wrapFocus", "children", "tag"]);
        this.listItemCount = 0;
        return (
        // https://github.com/Microsoft/TypeScript/issues/28892
        // @ts-ignore
        React.createElement(Tag, __assign({ className: this.classes }, otherProps), React.Children.map(children, this.renderChild)));
    };
    List.defaultProps = {
        'className': '',
        'nonInteractive': false,
        'dense': false,
        'avatarList': false,
        'twoLine': false,
        'singleSelection': false,
        'selectedIndex': -1,
        'handleSelect': function () { },
        'wrapFocus': true,
        'aria-orientation': VERTICAL,
        'tag': 'ul',
    };
    return List;
}(React.Component));
exports.default = List;


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// The MIT License
//
// Copyright (c) 2018 Google, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var classnames_1 = __webpack_require__(1);
;
function isAnchorElement(element) {
    return !!element.href;
}
function isFocusableElement(element) {
    return typeof element.focus === 'function';
}
var ListItem = /** @class */ (function (_super) {
    __extends(ListItem, _super);
    function ListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listItemElement_ = React.createRef();
        _this.renderChild = function (child) {
            if (typeof child === 'string' || typeof child === 'number' || child === null) {
                return child;
            }
            var tabIndex = _this.props.childrenTabIndex;
            var props = __assign({}, child.props, { tabIndex: tabIndex });
            return React.cloneElement(child, props);
        };
        return _this;
    }
    ListItem.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, shouldFocus = _a.shouldFocus, shouldFollowHref = _a.shouldFollowHref, shouldToggleCheckbox = _a.shouldToggleCheckbox;
        if (shouldFocus && !prevProps.shouldFocus) {
            this.focus();
        }
        if (shouldFollowHref && !prevProps.shouldFollowHref) {
            this.followHref();
        }
        if (shouldToggleCheckbox && !prevProps.shouldToggleCheckbox) {
            this.toggleCheckbox();
        }
    };
    Object.defineProperty(ListItem.prototype, "classes", {
        get: function () {
            var _a = this.props, className = _a.className, classNamesFromList = _a.classNamesFromList;
            return classnames_1.default('mdc-list-item', className, classNamesFromList);
        },
        enumerable: true,
        configurable: true
    });
    ListItem.prototype.focus = function () {
        var element = this.listItemElement_.current;
        if (isFocusableElement(element)) {
            element.focus();
        }
    };
    ListItem.prototype.followHref = function () {
        var element = this.listItemElement_.current;
        if (isAnchorElement(element)) {
            element.click();
        }
    };
    ListItem.prototype.toggleCheckbox = function () {
        // TODO(bonniez): implement
        // https://github.com/material-components/material-components-web-react/issues/352
    };
    ListItem.prototype.render = function () {
        var _a = this.props, 
        /* eslint-disable */
        className = _a.className, classNamesFromList = _a.classNamesFromList, childrenTabIndex = _a.childrenTabIndex, shouldFocus = _a.shouldFocus, shouldFollowHref = _a.shouldFollowHref, shouldToggleCheckbox = _a.shouldToggleCheckbox, 
        /* eslint-enable */
        attributesFromList = _a.attributesFromList, children = _a.children, Tag = _a.tag, otherProps = __rest(_a, ["className", "classNamesFromList", "childrenTabIndex", "shouldFocus", "shouldFollowHref", "shouldToggleCheckbox", "attributesFromList", "children", "tag"]);
        return (
        // https://github.com/Microsoft/TypeScript/issues/28892
        // @ts-ignore
        React.createElement(Tag, __assign({ className: this.classes }, otherProps, attributesFromList, { ref: this.listItemElement_ }), React.Children.map(children, this.renderChild)));
    };
    ListItem.defaultProps = {
        className: '',
        classNamesFromList: [],
        attributesFromList: {},
        childrenTabIndex: -1,
        tabIndex: -1,
        shouldFocus: false,
        shouldFollowHref: false,
        shouldToggleCheckbox: false,
        onKeyDown: function () { },
        onClick: function () { },
        onFocus: function () { },
        onBlur: function () { },
        tag: 'li',
    };
    return ListItem;
}(React.Component));
exports.default = ListItem;


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// The MIT License
//
// Copyright (c) 2018 Google, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var classnames_1 = __webpack_require__(1);
;
var ListItemGraphic = function (_a) {
    var _b = _a.tabIndex, tabIndex = _b === void 0 ? -1 : _b, // eslint-disable-line no-unused-vars
    graphic = _a.graphic, _c = _a.tabbableOnListItemFocus, tabbableOnListItemFocus = _c === void 0 ? false : _c, _d = _a.className, className = _d === void 0 ? '' : _d, otherProps = __rest(_a, ["tabIndex", "graphic", "tabbableOnListItemFocus", "className"]);
    var graphicProps = __assign({ className: classnames_1.default('mdc-list-item__graphic', className), tabIndex: tabbableOnListItemFocus ? tabIndex : -1 }, otherProps);
    return React.cloneElement(graphic, graphicProps);
};
exports.default = ListItemGraphic;


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// The MIT License
//
// Copyright (c) 2018 Google, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var classnames_1 = __webpack_require__(1);
;
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/14064
function isReactElement(element) {
    return element !== null && element.props !== undefined;
}
var ListItemText = function (_a) {
    var 
    /* eslint-disable react/prop-types */
    _b = _a.primaryText, 
    /* eslint-disable react/prop-types */
    primaryText = _b === void 0 ? '' : _b, _c = _a.secondaryText, secondaryText = _c === void 0 ? '' : _c, _d = _a.tabbableOnListItemFocus, tabbableOnListItemFocus = _d === void 0 ? false : _d, _e = _a.tabIndex, tabIndex = _e === void 0 ? -1 : _e, _f = _a.className, className = _f === void 0 ? '' : _f, 
    /* eslint-enable react/prop-types */
    otherProps = __rest(_a, ["primaryText", "secondaryText", "tabbableOnListItemFocus", "tabIndex", "className"]);
    var renderText = function (text, className) {
        if (text === undefined)
            return null;
        if (typeof text === 'string' || typeof text === 'number') {
            return (React.createElement("span", { className: className, tabIndex: tabbableOnListItemFocus ? tabIndex : -1 }, text));
        }
        if (!isReactElement(text))
            return null;
        var _a = text.props, textClassName = _a.className, otherProps = __rest(_a, ["className"]);
        className = classnames_1.default(className, textClassName);
        var props = __assign({}, otherProps, { className: className });
        return React.cloneElement(text, props);
    };
    if (!secondaryText) {
        return renderText(primaryText, classnames_1.default('mdc-list-item__text', className));
    }
    return (React.createElement("span", __assign({ className: classnames_1.default('mdc-list-item__text', className), tabIndex: tabbableOnListItemFocus ? tabIndex : -1 }, otherProps),
        renderText(primaryText, 'mdc-list-item__primary-text'),
        renderText(secondaryText, 'mdc-list-item__secondary-text')));
};
exports.default = ListItemText;


/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// The MIT License
//
// Copyright (c) 2018 Google, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var classnames_1 = __webpack_require__(1);
;
var ListItemMeta = function (_a) {
    var _b = _a.tabIndex, tabIndex = _b === void 0 ? -1 : _b, // eslint-disable-line no-unused-vars
    meta = _a.meta, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.tabbableOnListItemFocus, tabbableOnListItemFocus = _d === void 0 ? false : _d, otherProps = __rest(_a, ["tabIndex", "meta", "className", "tabbableOnListItemFocus"]);
    var metaElement;
    if (typeof meta === 'string') {
        metaElement = React.createElement("span", null, meta);
    }
    else {
        metaElement = meta;
    }
    var metaProps = __assign({ className: classnames_1.default('mdc-list-item__meta', className, metaElement.props.className), tabIndex: tabbableOnListItemFocus ? tabIndex : -1 }, otherProps);
    return React.cloneElement(metaElement, metaProps);
};
exports.default = ListItemMeta;


/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// The MIT License
//
// Copyright (c) 2018 Google, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var classnames_1 = __webpack_require__(1);
;
var ListDivider = function (_a) {
    var _b = _a.tag, Tag = _b === void 0 ? 'li' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.role, role = _d === void 0 ? 'separator' : _d, otherProps = __rest(_a, ["tag", "className", "role"]) // eslint-disable-line react/prop-types
    ;
    return (
    // https://github.com/Microsoft/TypeScript/issues/28892
    // @ts-ignore
    React.createElement(Tag, __assign({ className: classnames_1.default('mdc-list-divider', className), role: role }, otherProps)));
};
exports.default = ListDivider;


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// The MIT License
//
// Copyright (c) 2018 Google, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var classnames_1 = __webpack_require__(1);
;
var ListGroup = function (_a) {
    var _b = _a.tag, Tag = _b === void 0 ? 'div' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, children = _a.children, otherProps = __rest(_a, ["tag", "className", "children"]) // eslint-disable-line react/prop-types
    ;
    return (
    // https://github.com/Microsoft/TypeScript/issues/28892
    // @ts-ignore
    React.createElement(Tag, __assign({ className: classnames_1.default('mdc-list-group', className) }, otherProps), children));
};
exports.default = ListGroup;


/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// The MIT License
//
// Copyright (c) 2018 Google, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var classnames_1 = __webpack_require__(1);
;
var ListGroupSubheader = function (_a) {
    var _b = _a.tag, Tag = _b === void 0 ? 'h3' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, children = _a.children, otherProps = __rest(_a, ["tag", "className", "children"]) // eslint-disable-line react/prop-types
    ;
    return (
    // https://github.com/Microsoft/TypeScript/issues/28892
    // @ts-ignore
    React.createElement(Tag, __assign({ className: classnames_1.default('mdc-list-group__subheader', className) }, otherProps), children));
};
exports.default = ListGroupSubheader;


/***/ })

/******/ });
});
//# sourceMappingURL=list.js.map